import * as B from './Background.styled';
export const Background = () => {
	return <B.Background.Container />;
};
